<template>
    <div v-if="manufacturer?.media" class="h-12">
        <MiscLink
            v-if="manufacturer.link || brandExtension?.path"
            :to="brandExtension?.path != null ? brandExtension?.path : manufacturer.link"
            :title="manufacturer.translated?.name"
        >
            <NuxtImg
                :src="manufacturer.media?.url"
                height="48"
                :alt="manufacturer.media?.alt ? manufacturer.media?.alt : manufacturer.translated?.name"
                :title="manufacturer.media?.title ? manufacturer.media?.title : manufacturer.translated?.name"
                loading="lazy"
            />
        </MiscLink>

        <NuxtImg
            v-else
            :src="manufacturer.media?.url"
            height="48"
            :alt="manufacturer.media?.alt ? manufacturer.media?.alt : manufacturer.translated?.name"
            :title="manufacturer.media?.title ? manufacturer.media?.title : manufacturer.translated?.name"
            loading="lazy"
        />
    </div>

    <span v-else-if="manufacturer?.translated?.name" class="text-base-content-subtle text-sm mb-2 block">
        {{ manufacturer?.translated?.name }}
    </span>
</template>

<script setup lang="ts">
const { product } = useProduct()
const manufacturer = computed(() => {
    return product?.value?.manufacturer
})
const brandExtension = computed(() => {
    return product?.value?.extensions?.a4g_brand
})
</script>

